/**
* This file is automatically generated with the sync-cookies microproject
*
* You can regenerate it as follows:
*
* cd micro-projects/sync-cookies
* yarn build
*/

/* eslint-disable */

const cookiesToTrack = '_fprom_code,_fprom_track,register_widget,ajs_anonymous_id,cmplz_consented_services,cmplz_functional,cmplz_marketing,cmplz_policy_id,cmplz_preferences,cmplz_statistics'.split(',');
function getQueryString() {
    var key = false, res = {}, itm = null;
    var qs = location.search.substring(1);
    if (arguments.length > 0 && arguments[0].length > 1)
      key = arguments[0];
    var pattern = /([^&=]+)=([^&]*)/g;
    while (itm = pattern.exec(qs)) {
      if (key !== false && decodeURIComponent(itm[1]) === key)
        return decodeURIComponent(itm[2]);
      else if (key === false)
        res[decodeURIComponent(itm[1])] = decodeURIComponent(itm[2]);
    }
    return key === false ? res : null;
}
function setCookies() {
    const qs = getQueryString();
    if (!qs['xdc']) {
        return
    }
    try {
        Object.entries(JSON.parse(atob(decodeURIComponent(qs.xdc))))
            .forEach(([name, data]) => {
                if (!cookiesToTrack.includes(name)) {
                    return
                }
                const metadata = Object.entries(data)
                    .filter(([key]) => !Array.isArray(key) && ['max-age', 'expires'].includes(key.toLowerCase()))
                    .map(([key, datum]) => datum === true ? key : `${key}=${datum}`);
                if (!metadata.length) {
                    metadata.push('max-age=5184000');
                }
                const secure = process.env.VUE_APP_ENV === 'production' ? 'secure; ' : '';
                const cookie = `${name}=${data.value}; ${secure}path=/; ${metadata.join('; ')}`;
                document.cookie = cookie;
            });
    } catch (e) {
        console.error(e);
    }
    delete qs.xdc;
    let newQs = Object.entries(qs).map(([k,v]) => k + '=' + v).join('&');
    if (newQs.trim() !== '') {
        newQs = '?' + newQs;
    }
    window.history.replaceState({}, '', location.pathname + newQs);
}

export { setCookies as default };
